import React from 'react'
import { ReactComponent as AccordionArrow } from 'presentation/assets/icons/accordion-arrow.svg'
import CardNew from '../CardNew'
import * as S from './styles'

type AccordionProps = {
  items: {
    title: React.ReactElement
    content: React.ReactElement
    disabled?: boolean
  }[]
  padding?: string
  defaultExpanded?: boolean
}

const AccordionTest = ({ items, padding, defaultExpanded }: AccordionProps) => {
  return (
    <CardNew shadow="none" padding={padding}>
      {items.map((item, index) => (
        <S.StyledAccordion
          key={index}
          elevation={0}
          disabled={item.disabled}
          defaultExpanded={defaultExpanded}
        >
          <S.StyledAccordionSummary
            expandIcon={<AccordionArrow />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <S.StyledAccordionDetails>{item.title}</S.StyledAccordionDetails>
          </S.StyledAccordionSummary>
          <S.StyledAccordionContent>{item.content}</S.StyledAccordionContent>
        </S.StyledAccordion>
      ))}
    </CardNew>
  )
}

export default AccordionTest
